import {
  isTierList,
  listPath,
  LISTS_PATH,
  OVERVIEW_TAB,
  rootLists,
  SMART_LISTS_TAB,
  TIER_LISTS_TAB
} from '@/config/listSections'

const listPage = (tab, audiences) => ({
  name: tab.name,
  link: listPath(tab.id),
  match: [listPath(tab.id), ...audiences.map(audience => listPath(audience.id))]
})

export function buildCustomersNavItems({ isCatering = false, audiences = [] } = {}) {
  const lists = rootLists(audiences)
  return [
    { name: OVERVIEW_TAB.name, link: LISTS_PATH, exact: [LISTS_PATH, listPath(OVERVIEW_TAB.id)] },
    ...(isCatering ? [] : [listPage(TIER_LISTS_TAB, lists.filter(isTierList))]),
    listPage(
      SMART_LISTS_TAB,
      lists.filter(list => !isTierList(list))
    )
  ]
}

export default {
  bases: [LISTS_PATH],
  fetches: ['audiences?included=none'],
  build: ({ isCatering, mapType }) => buildCustomersNavItems({ isCatering, audiences: mapType('audience') })
}
